<script setup>
import { HubSpotChat as DashingHubSpotChat } from '@dashhudson/dashing-ui/hubspot-chat';
import { useSidePanel } from '@dashhudson/dashing-ui/side-panel';
import { computed, onMounted, onUnmounted } from 'vue';

import { VISION_AI_PANEL_TYPE } from '@/components/VisionAi/constants';
import { useHubspotFloatingStackLayout } from '@/composables/layout/useFloatingWidgetLayout';
import { useHubspotStore } from '@/stores/hubspot';

const hubspotStore = useHubspotStore();

const { visible: sidePanelVisible, type: sidePanelType } = useSidePanel();

const visionAiPanelOpen = computed(
  () => sidePanelVisible.value && sidePanelType.value === VISION_AI_PANEL_TYPE,
);

const { chatPanelTransformStyle, stackPositionClasses } = useHubspotFloatingStackLayout(
  () => visionAiPanelOpen.value,
);

onMounted(() => {
  hubspotStore.chatMounted();
});

onUnmounted(() => {
  hubspotStore.chatUnmounted();
});
</script>

<template>
  <div :class="stackPositionClasses" :style="[{ zIndex: '9999' }, chatPanelTransformStyle]">
    <DashingHubSpotChat
      v-model:open="hubspotStore.showConversation"
      :loading="hubspotStore.loadingWidget"
      :hide-trigger="!hubspotStore.ready"
      @update:open="hubspotStore.syncWidget"
    >
      <div id="dh-hubspot-chat" class="absolute h-full w-full" />
    </DashingHubSpotChat>
  </div>
</template>
